export default "__VITE_ASSET__Cu2Csut2__"